import * as yup from "yup";

export const FormationAreaFormValidation = yup.object().shape({
    description: yup.string()
        .required("O nome da área de formação é obrigatório"),
    idKnowledgeSubDomain: yup.string(),
    idKnowledgeDomain: yup.string(),
    status: yup.boolean().default(true),
});
